import React from 'react';
import { Colors } from '@common/tokens';
import { DisputeDiffSectionLabels } from '@pay-bill/components';

export const DisputeDiffSection = ({
  mode,
  children,
}: {
  mode: 'form' | 'view';
  children: React.ReactNode;
}) => {
  return (
    <div className="dispute-diff-section">
      <div className="shift-info">
        <DisputeDiffSectionLabels mode={mode} />
        {children}
      </div>
      <style jsx>
        {`
          .dispute-diff-section :global(.shift-info) {
            background-color: ${Colors.steelLightest};
            padding-top: 12px;
            padding-left: 12px;
            padding-right: 12px;
          }
          .dispute-diff-section :global(.table-form) {
            margin-top: 8px;
          }
          .dispute-diff-section :global(s),
          .dispute-diff-section :global(.table-label) {
            color: ${Colors.midnightLighter};
          }
          .dispute-diff-section :global(.table-row) {
            padding-bottom: 8px;
          }
          .dispute-diff-section :global(.ant-form-item) {
            margin-bottom: 12px;
          }
          .dispute-diff-section :global(.rate-line) {
            padding-top: 5px;
            display: block;
          }
        `}
      </style>
    </div>
  );
};
